import React from 'react'
import Link from 'next/link'
import CountUp from 'react-countup';
function Since({data}:any) {
  return (
    <section className='since'>
        <div className="container-fluid p-0">
            <div className="row g-0">
                <div className="col-lg-6 p-0">
                    <div className="since_left white" >
                        <div className="since_content" dangerouslySetInnerHTML={{ __html: data?.sinceContent || '' }}></div>
                        <Link href={`${data?.sinceButton?.url}`} className='cmn_btn' data-aos="fade-down" data-aos-delay="100">
                            <span>{data?.sinceButton?.title}</span>
                        </Link>
                    </div>
                </div>
                <div className="col-lg-6 p-0">
                    <div className="since_right">
                        <div className="since_list">
                            {/* {
                                data.since && data.since.map((since:any,index:any)=>{
                                    return (
                                        <div key={index} className="since_box" data-aos="fade-left" data-aos-delay="100">
                                            <h3><CountUp enableScrollSpy={true} end={since?.sinceData} /></h3>
                                            <div className="seperator"><span></span></div>
                                            <p>{since?.sinceTitle}</p>
                                        </div>
                                    )
                                })
                            } */}
                            {
                                data.since && data.since.map((since:any,index:any)=>{
                                    let endValue;
                                    let sign = '';
                                    if (typeof since.sinceData === 'string' && since.sinceData.endsWith('%')) {
                                        endValue = parseFloat(since.sinceData);
                                        sign = '%';
                                    } else if (!isNaN(Number(since.sinceData))) {
                                        endValue = Number(since.sinceData);
                                    } else {
                                        endValue = since.sinceData;
                                    }

                                    return (
                                        <div key={index} className="since_box" data-aos="fade-left" data-aos-delay="100">
                                            {typeof endValue === 'number' ? (
                                                <h3><CountUp enableScrollSpy={true} end={endValue} />{sign}</h3>
                                            ) : (
                                                <h3>{endValue}</h3>
                                            )}
                                            <div className="seperator"><span></span></div>
                                            <p>{since?.sinceTitle}</p>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Since